module.exports = "./static/img_personal_bg.70452a70.png";